import { Box, AbsoluteCenter, Flex, Text, VStack } from "@chakra-ui/react";

function PageNotFound() {
  return (
    <Box height="100vh">
      <AbsoluteCenter>
        <Flex
          alignItems={"center"}
          justifyContent="center"
          textAlign={"center"}
        >
          <VStack spacing={2}>
            <Text
              textAlign={"center"}
              fontWeight="bold"
              fontSize="8em"
              color="#4C4E66"
            >
              404
            </Text>
            <Text fontSize={"1.5em"} color="#A5A6B1">
              {"PAGE NOT FOUND"}
            </Text>
          </VStack>
        </Flex>
      </AbsoluteCenter>
    </Box>
  );
}

export default PageNotFound;
